var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { class: _vm.rootClass }, [
    _c("em", { staticClass: "ico_cafe ico_reply" }, [_vm._v("답글")]),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "link_group",
        class: _vm.CAT,
        attrs: { href: _vm.linkUrl }
      },
      [
        !_vm.article.dummy
          ? [
              _c("strong", { staticClass: "tit_group" }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _vm.hasComment
                ? _c("span", { staticClass: "num_cmt" }, [
                    _c("span", { staticClass: "sr_only" }, [_vm._v("댓글")]),
                    _vm._v("("),
                    _c("span", { staticClass: "num_placeholder" }, [
                      _vm._v(_vm._s(_vm.article.commentCount))
                    ]),
                    _vm._v(")")
                  ])
                : _vm._e()
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }